export default {
  bagFees: 'Pueden aplicarse cargos adicionales por equipaje',
}
